var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2462_57442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2462_57442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5026 17.4993C2.04427 17.4993 1.65191 17.3362 1.32552 17.0098C0.999132 16.6834 0.835938 16.291 0.835938 15.8327V5.83268C0.835938 5.59657 0.915799 5.39865 1.07552 5.23893C1.23524 5.07921 1.43316 4.99935 1.66927 4.99935C1.90538 4.99935 2.1033 5.07921 2.26302 5.23893C2.42274 5.39865 2.5026 5.59657 2.5026 5.83268V15.8327H15.8359C16.072 15.8327 16.27 15.9125 16.4297 16.0723C16.5894 16.232 16.6693 16.4299 16.6693 16.666C16.6693 16.9021 16.5894 17.1 16.4297 17.2598C16.27 17.4195 16.072 17.4993 15.8359 17.4993H2.5026ZM5.83594 14.166C5.3776 14.166 4.98524 14.0028 4.65885 13.6764C4.33247 13.35 4.16927 12.9577 4.16927 12.4993V3.33268C4.16927 2.87435 4.33247 2.48199 4.65885 2.1556C4.98524 1.82921 5.3776 1.66602 5.83594 1.66602H9.3151C9.53733 1.66602 9.74913 1.70768 9.95052 1.79102C10.1519 1.87435 10.329 1.9924 10.4818 2.14518L11.6693 3.33268H17.5026C17.9609 3.33268 18.3533 3.49588 18.6797 3.82227C19.0061 4.14865 19.1693 4.54102 19.1693 4.99935V12.4993C19.1693 12.9577 19.0061 13.35 18.6797 13.6764C18.3533 14.0028 17.9609 14.166 17.5026 14.166H5.83594ZM5.83594 12.4993H17.5026V4.99935H10.9818L9.3151 3.33268H5.83594V12.4993Z",
    fill: "#F5F4F3",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsIcon);
export default __webpack_public_path__ + "static/media/contracts-icon.41346c9bdba7d64ff47ced2c55bd6724.svg";
export { ForwardRef as ReactComponent };